import React from 'react';
import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home',            to: '/'               },
  { label: 'About',           to: '/about'          },
  { label: 'Brands',          to: '/brands'         },
  { label: 'Operating Model', to: '/operating-model'},
  { label: 'Contact',         to: '/contact'        },
  { label: 'Privacy Policy',  to: '/privacy-policy' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer" aria-label="Site footer">
      <div className="container">
        <div className="footer__grid">

          {/* Col 1 — Brand */}
          <div>
            <Link to="/" aria-label="Driven 2 LLC — Home">
              <img
                src="/images/driven2-logo.png"
                alt="Driven 2 LLC"
                className="footer__logo-img"
              />
            </Link>
            <p className="footer__tagline">
              A disciplined holding company that builds, owns, and operates a portfolio
              of digital brands through centralized governance and long-term stewardship.
            </p>
            <div style={{ marginTop: 'var(--sp-6)' }}>
              <div style={{ width: '3rem', height: '1px', background: 'linear-gradient(90deg, var(--gold-500), transparent)' }} />
            </div>
          </div>

          {/* Col 2 — Navigation */}
          <div>
            <div className="footer__col-heading">Navigation</div>
            <nav className="footer__nav" aria-label="Footer navigation">
              {NAV_LINKS.map(({ label, to }) => (
                <Link key={to} to={to}>{label}</Link>
              ))}
            </nav>
          </div>

          {/* Col 3 — Contact */}
          <div>
            <div className="footer__col-heading">Contact</div>
            <div className="footer__contact-row">
              <div className="footer__contact-item">
                <div className="footer__contact-lbl">Phone</div>
                <div className="footer__contact-val"><a href="tel:9046387199">904-638-7199</a></div>
              </div>
              <div className="footer__contact-item">
                <div className="footer__contact-lbl">Email</div>
                <div className="footer__contact-val"><a href="mailto:info@driven2.net">info@driven2.net</a></div>
              </div>
              <div className="footer__contact-item">
                <div className="footer__contact-lbl">Web</div>
                <div className="footer__contact-val">
                  <a href="https://www.driven2.net" target="_blank" rel="noreferrer">www.driven2.net</a>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="footer__bottom">
          <div className="footer__copy">&copy; {year} Driven 2 LLC. All rights reserved.</div>
          <div className="footer__legal-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <a href="mailto:info@driven2.net">info@driven2.net</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
